import angular from 'angular'

import component from './collapsable-invoices.component'

let module = angular.module('collapsableInvoices', [])

.component('collapsableInvoices', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/collapsable-invoices/index.js